import { IUseGraphqlQueryOptions } from '@proscom/prostore-apollo-react';
import { skipIfNull } from '@proscom/prostore';
import { useAuthGraphqlQuery } from '../../../common/hooks/utils/useAuthGraphqlQuery';
import { OfferType } from '../../types';
import { QUERY_GET_OFFER } from '../../queries/offers';

export interface UseArticleVars {
  id: string;
}

const queryOptions: IUseGraphqlQueryOptions<
  UseArticleVars | null,
  OfferType | null
> = {
  query: QUERY_GET_OFFER,
  mapData: (result) => result.offer,
  skipQuery: skipIfNull(null)
};

export function useOffer(id?: string) {
  return useAuthGraphqlQuery({
    queryOptions,
    variables: id ? { id } : null
  });
}
